export default "__VITE_ASSET__BWJGJxD2__"